<template>
  <div class="add-form">
    <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
      <FormItem label="是否显示">
        <RadioGroup v-model="form.status">
          <Radio label="1">显示</Radio>
          <Radio label="2">隐藏</Radio>
        </RadioGroup>
      </FormItem>
      <Row>
        <vue-draggable v-model="form.banner">
          <Col span="24" v-for="(item, index) in form.banner" :key="index">
            <div class="title">广告{{ index + 1 }}</div>
            <FormItem prop="status">
              <div class="banner-item">
                <div class="left">
                  <upload-file-one
                    :path="item.path"
                    :url="item.url"
                    @on-change="coversChange($event, index)"
                    tips="* 拖拽可排序"
                  ></upload-file-one>
                </div>
                <div class="right">
                  <span class="span-title">请选择类型：</span>
                  <RadioGroup v-model="item.target_type">
                    <Radio label="0">纯展示</Radio>
                    <Radio label="1">文章</Radio>
                    <Radio label="2">赛事</Radio>
                    <Radio label="3">活动</Radio>
                  </RadioGroup>
                  <div style="margin-top: 10px" v-if="item.target_type != 0">
                    <span class="span-title">请选择：</span>
                    <Select filterable v-if="item.target_type == 1" style="width: 200px" v-model="item.target_id">
                      <Option
                        v-for="(item, index) in apiData.articleList"
                        :key="index"
                        :label="item.title"
                        :value="item.id"
                      ></Option>
                    </Select>
                    <Select filterable v-if="item.target_type == 2" style="width: 200px" v-model="item.target_id">
                      <Option
                        v-for="(item, index) in apiData.competitionsList"
                        :key="index"
                        :label="item.title"
                        :value="item.id"
                      ></Option>
                    </Select>
                    <Select filterable v-if="item.target_type == 3" style="width: 200px" v-model="item.target_id">
                      <Option
                        v-for="(item, index) in apiData.activityList"
                        :key="index"
                        :label="item.title"
                        :value="item.id"
                      ></Option>
                    </Select>
                  </div>
                  <div v-if="form.banner.length > 1" class="subtract btn" @click="deleteAdv(index)">
                    <Icon color="#ed4014" size="18" type="md-close-circle" />
                    <span>删除</span>
                  </div>
                </div>
              </div>
            </FormItem>
          </Col>
        </vue-draggable>
        <div
          v-if="form.banner.length < 5"
          class="add btn"
          style="margin-bottom: 20px; margin-left: 100px"
          @click="addAdv"
        >
          <Icon color="#2d8cf0" size="18" type="ios-add-circle" />
          <span>新增</span>
        </div>
      </Row>
    </Form>
    <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
  </div>
</template>

<script>
  import * as apiSetting from '@/api/setting'
  import * as apiArticle from '@/api/article'
  import * as apiCompetition from '@/api/activity/competitions'
  import * as apiActivity from '@/api/activity/activity'
  import uploadFileOne from '@/components/upload-custom/upload-file-one.vue'
  import vueDraggable from 'vuedraggable'
  export default {
    name: 'add-form',
    components: {
      uploadFileOne,
      vueDraggable,
    },
    data() {
      return {
        query: {},
        search: {},
        diyDom: {},
        // 表单数据
        form: {
          status: '1',
          banner: [
            {
              path: '',
              url: '',
              target_type: '0',
              target_id: '',
            },
          ],
        },
        diyData: {
          rules: {},
        },
        apiData: {
          articleList: [], // 文章
          competitionsList: [], // 赛事
          activityList: [], // 活动
        },
      }
    },
    computed: {},
    methods: {
      // 获取文章不分页
      getArticle() {
        apiArticle.apiArticleList().then(res => {
          this.apiData.articleList = res.data
        })
      },
      // 获取赛事列表
      getCompetitionsList() {
        apiCompetition.apiCompetitionsList().then(res => {
          this.apiData.competitionsList = res.data
        })
      },
      // 获取活动列表
      getActivityList() {
        apiActivity.apiActivitiesList().then(res => {
          this.apiData.activityList = res.data
        })
      },
      // 获取详情
      getDetail() {
        this.$store.commit('setSpinShow', true)
        apiSetting
          .apiGetSystem('banner')
          .then(res => {
            if (!Array.isArray(res.data)) {
              if (JSON.stringify(res.data) !== '{}') {
                this.form.status = res.data.status
                this.form.banner = res.data.lists
              }
            }
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      // 图片封面
      coversChange(data, index) {
        this.form.banner[index].url = data.url
        this.form.banner[index].path = data.path
      },
      // 查看文件
      lookFile(file) {
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.target = '_blank'
        a.href = file
        a.click()
        document.body.removeChild(a)
      },
      // 删除文件
      deleteFile(index) {
        this.form.banner[index].url = ''
        this.form.banner[index].path = ''
      },
      // 新增广告
      addAdv() {
        this.form.banner.push({
          path: '',
          url: '',
          target_type: '0',
          target_id: '',
        })
      },
      // 删除广告
      deleteAdv(index) {
        this.form.banner.splice(index, 1)
      },
      submit() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            apiSetting
              .apiSetSystem('banner', {
                banner: {
                  lists: this.form.banner,
                  status: this.form.status,
                },
              })
              .then(() => {
                this.$Message.success('保存成功')
                this.$bus.$emit('on-change')
                this.getDetail()
              })
          }
        })
      },
    },
    beforeDestroy() {
      this.$off('on-change')
    },
    mounted() {
      this.getArticle()
      this.getCompetitionsList()
      this.getActivityList()
      this.getDetail()
    },
  }
</script>

<style scoped lang="less">
  .add-form {
    border: 1px solid #ededed;
    margin: 0 20px;
    padding: 26px 20px;

    .title {
      border-left: 5px solid #2d8cf0;
      padding: 0 0 0 10px;
      margin: 0 20px 20px;
      font-weight: bold;
    }
  }
  .upload-wrap {
    display: flex;
  }
  .look-img {
    display: flex;
    margin-right: 10px;
    align-items: center;
    width: 150px;
    height: 150px;
    border: 1px dashed rgba(197, 197, 197, 1);
    text-align: center;
    justify-content: space-evenly;
    position: relative;
    overflow: hidden;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    text-align: center;
  }

  .look-img:hover .demo-upload-list-cover {
    display: block;
  }

  .demo-upload-list-cover i {
    line-height: 150px;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
  .banner-item {
    display: flex;
    justify-content: left;
    border: 1.5px solid #ededed;
    padding: 10px;
    width: 50%;
    .left {
      margin-right: 20px;
    }
    .span-title {
      display: inline-block;
      width: 80px;
    }
  }
  .btn {
    cursor: pointer;
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
